import styled from 'styled-components';
export const Container = styled.div `
  display: flex;
  align-items: center;
  gap: 8px;
`;
export const Badge = styled.div `
  background: linear-gradient(var(--bg-pro-gradient-start), var(--bg-pro-gradient-end));
  background: radial-gradient(
    135.71% 135.71% at 28.85% 0%,
    var(--bg-pro-gradient-start) 0%,
    var(--bg-pro-gradient-end) 100%
  );
  border-radius: 1000px;
  padding: 1px 6px 1px;
  font-size: 10px;
  line-height: 14px;
  font-weight: 700;
  color: var(--color-gray-100);
`;
export const Label = styled.div `
  color: var(--text-pro);
  font-size: var(--font-size-400);
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-400);
`;
